// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"61e431de","441":"61e431de","715":"a6636b6f"}[chunkId] + ".chunk.css";
};